import React from 'react';
import { SplitScreenLayout } from '@dopomogai/ui';

function useMediaQuery(query: string) {
  const [matches, setMatches] = React.useState(
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    mql.addEventListener?.('change', onChange);
    // Fallback for Safari
    // @ts-ignore
    mql.addListener?.(onChange);
    return () => {
      mql.removeEventListener?.('change', onChange);
      // @ts-ignore
      mql.removeListener?.(onChange);
    };
  }, [query]);
  return matches;
}

type Props = { left: React.ReactNode; right: React.ReactNode };

export function AgentPageLayout({ left, right }: Props) {
  const isMdUp = useMediaQuery('(min-width: 768px)'); // md
  const orientation = isMdUp ? 'horizontal' as const : 'vertical' as const;

  return (
    <div className="container mx-auto px-4 py-6 md:py-8">
      <SplitScreenLayout orientation={orientation} initialSizes={[65, 35]} minPaneSize={280}>
        <main aria-label="Agent content" className="min-w-0">
          {left}
        </main>
        <aside
          aria-label="Sticky rail"
          className="lg:sticky lg:top-24 h-fit lg:max-h-[calc(100vh-7rem)] lg:overflow-auto"
        >
          {right}
        </aside>
      </SplitScreenLayout>
    </div>
  );
}